import { useAtomValue } from "jotai";
import { questionnaireValidationDependenciesAtom } from "./state/questionnaireValidationDependenciesAtom";

type ValidationDependenciesMap = Record<string, string[]>;

/**
 * Hook that returns a memoized map of validation dependencies.
 *
 * Instead of extracting dependencies for each question individually,
 * this hook uses a derived atom that processes all validations once and
 * creates a lookup map. This is more efficient when there are many questions
 * but few validation rules.
 *
 * The map is automatically recomputed when validations change.
 *
 * @returns Map of question names to their validation dependencies
 *
 * @example
 * ```typescript
 * const dependenciesMap = useValidationDependencies();
 * const deps = dependenciesMap["confirm_email"]; // ["confirm_email", "email"]
 * ```
 */
export function useValidationDependencies(): ValidationDependenciesMap {
  return useAtomValue(questionnaireValidationDependenciesAtom);
}
